import { Controller } from "@hotwired/stimulus";

const SCOPE = '[data-scenario-facility-picker-target~="scope"]';

/**
 * Step 1 facility picker: intermediaries with their facilities, then direct
 * connections. A scope is anything with its own checkbox (a section or one
 * intermediary). Searching and country filtering stay with scenario-list-filter,
 * which hides rows and then dispatches "filtered".
 */
export default class extends Controller {
  static targets = ["scope", "scopeCheckbox", "group", "toggle", "body", "count", "facility"];

  static values = { countTemplate: String };

  connect() {
    this.refresh();
  }

  toggleScope(event) {
    const visible = this.facilitiesIn(event.target.closest(SCOPE)).filter(
      (checkbox) => !this.rowOf(checkbox).classList.contains("hidden"),
    );
    this.setChecked(visible, event.target.checked);
  }

  toggleFacility(event) {
    this.setChecked([event.target], event.target.checked);
  }

  toggleOpen(event) {
    const group = event.currentTarget.closest(SCOPE);
    group.dataset.open = group.dataset.open === "true" ? "false" : "true";
    this.refresh();
  }

  // A facility listed under several groups is one facility: its checkboxes move together.
  setChecked(checkboxes, checked) {
    const facilityIds = new Set(checkboxes.map((checkbox) => checkbox.value));
    this.facilityTargets.forEach((checkbox) => {
      if (facilityIds.has(checkbox.value)) checkbox.checked = checked;
    });
    this.refresh();
  }

  refresh() {
    const filtering = this.facilityTargets.some((checkbox) => this.rowOf(checkbox).classList.contains("hidden"));

    this.scopeCheckboxTargets.forEach((scopeCheckbox) => {
      const scope = scopeCheckbox.closest(SCOPE);
      const facilities = this.facilitiesIn(scope);
      const checked = facilities.filter((checkbox) => checkbox.checked).length;
      const matches = facilities.filter((checkbox) => !this.rowOf(checkbox).classList.contains("hidden")).length;

      scopeCheckbox.checked = facilities.length > 0 && checked === facilities.length;
      scopeCheckbox.indeterminate = checked > 0 && checked < facilities.length;
      scope.classList.toggle("hidden", matches === 0);

      if (!this.groupTargets.includes(scope)) return;

      const open = scope.dataset.open === "true" || filtering;
      const within = (targets) => targets.find((element) => scope.contains(element));
      within(this.bodyTargets).classList.toggle("hidden", !open);
      within(this.toggleTargets).setAttribute("aria-expanded", String(open));
      within(this.toggleTargets).querySelector("svg")?.classList.toggle("rotate-180", open);
      within(this.countTargets).textContent = this.countTemplateValue
        .replace("%{selected}", checked)
        .replace("%{total}", facilities.length);
    });
  }

  facilitiesIn(scope) {
    return this.facilityTargets.filter((checkbox) => scope.contains(checkbox));
  }

  rowOf(checkbox) {
    return checkbox.closest('[data-scenario-list-filter-target="row"]');
  }
}
